import { PaginationRequestParams } from "@/common/mixins/pagination";
import { HTTPClient } from "../common/HTTPClient";
export interface CreateOrderItemsRequestParams {
  orderId: number;
  items: CreateOrderItemRequestParams[];
}
export interface CreateOrderItemRequestParams {
  itemId: number;
  price: number;
  amount: number;
  total: number;
}

export interface UpdateMarkDuplicateRequestParams {
  markOrderId: number[];
  unmarkOrderId: number[];
}

export class OrderClient {
  constructor(private httpClient: HTTPClient) {}

  public async getDuplicateOrders(): Promise<any> {
    const { data } = await this.httpClient.request({
      url: "/orders/duplicate",
      method: "GET"
    });

    return data;
  }
  public async deleteRealDuplicateOrders(): Promise<any> {
    const { data } = await this.httpClient.request({
      url: `/orders/real-duplicate`,
      method: "DELETE"
    });

    return data;
  }

  public async getOrderInfoByMcNumber(mcNumber: string): Promise<any> {
    const { data } = await this.httpClient.request({
      url: `/orders/${mcNumber}`,
      method: "GET"
    });

    return data;
  }

  public async getOrderInfoByMcNumberForFixOrder(
    mcNumber: string
  ): Promise<any> {
    const { data } = await this.httpClient.request({
      url: `/orders/fix-order/${mcNumber}`,
      method: "GET"
    });

    return data;
  }

  public async patchDuplicateOrder(
    params: UpdateMarkDuplicateRequestParams
  ): Promise<any> {
    const { data } = await this.httpClient.request({
      url: `/orders/mark-duplicate`,
      method: "PATCH",
      data: params
    });

    return data;
  }

  public async postOrderItems(
    params: CreateOrderItemsRequestParams
  ): Promise<any> {
    const { data } = await this.httpClient.request({
      url: "/orders/orderItem",
      method: "POST",
      data: params
    });
    return data;
  }

  public async updateDeliveryMode(
    mcNumber: string,
    deliveryModeId: string
  ): Promise<any> {
    const { data } = await this.httpClient.request({
      url: "/orders/delivery-mode",
      method: "PATCH",
      data: {
        mcNumber,
        deliveryModeId
      }
    });
    return data;
  }

  public async holdOrder(mcNumber: string): Promise<any> {
    const { data } = await this.httpClient.request({
      url: "/orders/hold-order",
      method: "POST",
      data: {
        mcNumber
      }
    });
    return data;
  }

  public async getHoldOrdersList(
    params: PaginationRequestParams
  ): Promise<any> {
    const { data } = await this.httpClient.request({
      url: "/orders/hold-order-list",
      method: "GET",
      params
    });
    return data;
  }

  public async cancelHoldOrderStatus(id: number): Promise<any> {
    const { data } = await this.httpClient.request({
      url: "/orders/cancel-hold-order",
      method: "POST",
      data: {
        id
      }
    });
    return data;
  }

  public async reverseHoldOrderStatus(id: number): Promise<any> {
    const { data } = await this.httpClient.request({
      url: "/orders/reverse-hold-order",
      method: "POST",
      data: {
        id
      }
    });
    return data;
  }

  public async updateOderMcStatus(mcNumber: string): Promise<any> {
    const { data } = await this.httpClient.request({
      url: "/orders/update-mcStatus",
      method: "PATCH",
      data: {
        mcNumber
      }
    });
    return data;
  }
}
